'use client';

// Corner badge for partially-found parts in check mode: a ring that fills with
// the found fraction. Deliberately without digits - the exact count already
// lives in the label under the part, so numbers stay in one place.
export function PartialRing({ fraction = 0, style }) {
  const r = 8;
  const circumference = 2 * Math.PI * r;
  // Keep at least a visible sliver so 1-of-many still reads as "in progress"
  const filled = Math.max(0.08, Math.min(1, fraction));
  return (
    <svg
      width={24}
      height={24}
      aria-hidden="true"
      style={{
        position: 'absolute',
        top: 4,
        right: 4,
        zIndex: 10,
        transform: 'rotate(-90deg)',
        filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.2))',
        ...style,
      }}
    >
      <circle cx={12} cy={12} r={r} fill="rgba(255,255,255,0.9)" stroke="#dee2e6" strokeWidth={4} />
      <circle
        cx={12}
        cy={12}
        r={r}
        fill="none"
        stroke="#228be6"
        strokeWidth={4}
        strokeDasharray={`${circumference * filled} ${circumference}`}
        strokeLinecap="round"
      />
    </svg>
  );
}
